"use strict";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const sliderEl = document.querySelector(".o-home-testimonials__list");
        if (!sliderEl) return;

        const swiper = new Swiper(sliderEl, {
            modules: [Navigation],
            loop: true,
            spaceBetween: 26,
            autoHeight: true,
            slidesPerView: "auto",
            loopAdditionalSlides: 2,
            navigation: {
                nextEl: ".o-home-testimonials__arrow--next",
                prevEl: ".o-home-testimonials__arrow--prev",
            },
            slideToClickedSlide: true,
        });
    });
}
